/*
* premierstreets
* version 4.5
* http://www.premierstreets.com
*
* Copyright (c) 2021 premier streets
* Author premier streets <support@premierstreets.com>
* Licensed under the MIT license.
*/
import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
// components
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { CONTAINERS } from './common/index';
import { DetailPageComponent } from './pages/detail-page/detail-page.component';
import { AuthGuard } from '../core/service/auth.guard';
import { LayoutAuthGuard } from '../core/service/layout_auth.guard';
import { UnderDevelopingComponent } from './pages/layout/under-developing/under-developing.component';
import { GetDirectionsComponent } from './shared/get-directions/get-directions.component';
import { SetPasswordComponent } from './pages/Authentication/set-password/set-password.component';
import { MarketPlaceComponent } from './pages/marketplace/marketplace.component';
import { EntertainmentOutsideVenueComponent } from './pages/entertainment-outside-venue/entertainment-outside-venue.component';
import { VendorResolverService } from './resolvers/vendor-resolver.service';


export const routes: Routes = [
	{
		path: '',
		resolve: {
			vendor: VendorResolverService
		},
		component: CONTAINERS.LayoutContainerComponent,
		canActivate: [LayoutAuthGuard],
		children: [
			{ path: 'pbs', redirectTo: '/', pathMatch: 'full' },
			{
				path: '',
				loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule)
			},
			{
				path: 'home',
				loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule)
			},

			{
				path: 'underdeveloping',
				component: UnderDevelopingComponent,
				data: {
					urls: [{ title: 'UNDER DEVELOPING', url: '' }]
				}
			},
			{
				path: 'getdirections',
				component: GetDirectionsComponent,
				data: {
					urls: [{ title: 'Get Directions', url: '' }]
				}
			},
			{
				path: 'account',
				canActivate: [AuthGuard],
				loadChildren: () => import('./pages/account/account.module').then(m => m.AccountModule),
				data: {
					urls: [{ title: 'Account Settings', url: '' }]
				}
			},
			// {
			//   path: 'wishlist',
			//   canActivate: [AuthGuard],
			//   loadChildren: () => import('./pages/wishlist/wishlist.module').then(m => m.WishlistModule),
			//   data: {
			//     urls: [{ title: 'Wishlist', url: '' }]
			//   }
			// },
			{
				path: 'compare',
				loadChildren: () => import('./pages/compare/compare.module').then(m => m.CompareModule),
				data: {
					urls: [{ title: 'Products', url: '/products' },
					{ title: 'Product Compare' }]
				}
			},
			{
				path: 'cart',
				loadChildren: () => import('./pages/cart/cart.module').then(m => m.CartModule),
				data: {
					urls: [{ title: 'Cart', url: '' }]
				}
			},
			{
				path: 'checkout',
				// canActivate: [AuthGuard],
				loadChildren: () => import('./pages/checkout/checkout.module').then(m => m.CheckoutModule),
				data: {
					urls: [{ title: 'Checkout', url: '' }]
				}
			},
			{
				path: 'pay/:id',
				// canActivate: [AuthGuard],
				loadChildren: () => import('./pages/remainder-pay/remainder-pay.module').then(m => m.RemainderPayModule),
				data: {
					urls: [{ title: 'review and pay', url: '' }]
				}
			},
			{
				path: 'review-and-pay',
				// canActivate: [AuthGuard],
				loadChildren: () => import('./pages/review-and-pay/review-and-pay.module').then(m => m.ReviewAndPayModule),
				data: {
					urls: [{ title: 'review and pay', url: '' }]
				}
			},
			{
				path: 'contact-us',
				loadChildren: () => import('./pages/contact-us/contact-us.module').then(m => m.ContactUsModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'Contact-us', url: '' }]
				}
			},
			{
				path: 'about',
				loadChildren: () => import('./pages/about/about.module').then(m => m.AboutModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'About', url: '' }]
				}
			},
			{
				path: 'booking',
				loadChildren: () => import('./pages/booking-payment/booking-payment.module').then(m => m.BookingPaymentModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'Booking', url: '' }]
				}
			},
			{
				path: 'quote-payment',
				loadChildren: () => import('./pages/quote-payment/quote-payment.module').then(m => m.QuotePaymentModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'Quote', url: '' }]
				}
			},
			{
				path: 'delivery',
				loadChildren: () => import('./pages/delivery/delivery.module').then(m => m.DeliveryModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'delivery', url: '' }]
				}
			},
			{
				path: 'customer-service',
				loadChildren: () => import('./pages/customer-service/customer.module').then(m => m.CustomerModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'customer-service', url: '' }]
				}
			},
			{
				path: 'rewards',
				loadChildren: () => import('./pages/reward-point/reward-point.module').then(m => m.RewardModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'rewards', url: '' }]
				}
			},
			{
				path: 'promotional-codes',
				loadChildren: () => import('./pages/promotional-codes/promotional-codes.module').then(m => m.PromotionalCodesModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'promotional-codes', url: '' }]
				}
			},
			{
				path: 'vr-and-ar',
				loadChildren: () => import('./pages/vr-and-ar/vr-and-ar.module').then(m => m.VrAndArModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'vr-and-ar', url: '' }]
				}
			},
			{
				path: 'sells',
				loadChildren: () => import('./pages/sells/sells.module').then(m => m.SellsModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'sells', url: '' }]
				}
			},
			{
				path: 'faq',
				loadChildren: () => import('./pages/faq/faq.module').then(m => m.FaqModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'faq', url: '' }]
				}
			},
			{
				path: 'help',
				loadChildren: () => import('./pages/help/help.module').then(m => m.HelpModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'help', url: '' }]
				}
			},


			{
				path: 'track-order',
				loadChildren: () => import('./pages/track-order/track-order.module').then(m => m.TrackOrderModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'Track Order', url: '' }]
				}
			},
			{
				path: 'vendor',
				loadChildren: () => import('./pages/vendor/vendor.module').then(m => m.VendorModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'Vendor Sign Up', url: '' }]
				}
			},
			{
				path: 'vendors/:id',
				loadChildren: () => import('./pages/vendors/vendors.module').then(m => m.VendorsModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'Vendor Sign Up', url: '' }]
				}
			},
			{
				path: 'vendors',
				loadChildren: () => import('./pages/vendors/vendors.module').then(m => m.VendorsModule)
			},
			{
				path: 'vendor-detail',
				loadChildren: () => import('./pages/vendor-detail/vendor-detail.module').then(m => m.VendorDetailModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'Vendor Details', url: '' }]
				}
			},



			{
				path: 'our-story/:id',
				loadChildren: () => import('./pages/our-story/our-story.module').then(m => m.OurstoryModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'our-story', url: '' }]
				}
			},
			{
				path: 'auth',
				// canActivate: [AuthGuard],
				loadChildren: () => import('./pages/Authentication/authentication.module').then(m => m.AuthenticationModule),
				data: {
					urls: [{ title: 'Sign In', url: '' }],
					permission: 'auth'
				}
			},
			{
				path: 'page-detail/:id',
				data: {
					urls: [{ title: 'page-detail', url: '' }],
				},
				component: DetailPageComponent
			},
			{
				path: 'marketplace/:id/:country',
				data: {
					urls: [{ title: 'MarketPlace', url: '' }],
				},
				component: MarketPlaceComponent
			},
			{
				path: 'marketplace/:id/:country/:vendorPrefixId',
				data: {
					urls: [{ title: 'MarketPlace', url: '' }],
				},
				component: MarketPlaceComponent
			},
			{
				path: 'products',
				loadChildren: () => import('./pages/products/products.module').then(m => m.ProductsModule),
			},
			{
				path: 'products/:id',
				loadChildren: () => import('./pages/products/products.module').then(m => m.ProductsModule),
				data: {
					urls: [{ title: 'Product Detail ', url: '' }]
				}
			},



			{
				path: 'blogs',
				loadChildren: () => import('./pages/blogs/blogs.module').then(m => m.BlogsModule),
			},
			{
				path: 'services',
				loadChildren: () => import('./pages/services/services.module').then(m => m.ServicesModule),
			},
			{
				path: 'stock-checkout',
				loadChildren: () => import('./pages/stock-checkout/stock-checkout.module').then(m => m.StockCheckoutModule),
				data: {
					urls: [{ title: 'stock-checkout', url: '' }],
				},
			},
			{
				path: 'socialhub-user',
				loadChildren: () => import('./pages/social-hub-user/socialhub-user.module').then(m => m.SocialhubuserModule),
				canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'socialhub-user', url: '' }]
				}
			},
			{
				path: 'socialhub-profile/:id',
				loadChildren: () => import('./pages/social-hub-profile/socialhub-profile.module').then(m => m.SocialhubProfileModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'socialhub-profile', url: '' }]
				}
			},
			{
				path: 'socialhub-shop',
				loadChildren: () => import('./pages/social-hub-shop/socialhub-shop.module').then(m => m.SocialhubshopModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'socialhub-shop', url: '' }]
				}
			},
			{
				path: 'social-hub',
				loadChildren: () => import('./pages/social-hub/social-hub.module').then(m => m.SocialhubModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'social-hub', url: '' }]
				}
			},
			{
				path: 'social-chat',
				loadChildren: () => import('./pages/social-chat/social-chat.module').then(m => m.SocialChatModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'social-chat', url: '' }]
				}
			},
			{
				path: 'social-chat/:id',
				loadChildren: () => import('./pages/social-chat/social-chat.module').then(m => m.SocialChatModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'social-chat', url: '' }]
				}
			},
			{
				path: 'vendor-feedback',
				loadChildren: () => import('./pages/vendor-feedback/vendor-feedback.module').then(m => m.VendorFeedbackModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'vendor-feedback', url: '' }]
				}
			},
			{
				path: 'customer-survey',
				loadChildren: () => import('./pages/customer-survey/customer-survey.module').then(m => m.CustomerSurveyModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'customer-survey', url: '' }]
				}
			},

			{
				path: 'refund-policy',
				loadChildren: () => import('./pages/refund-policy/refund-policy.module').then(m => m.RefundPolicyModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'refund-policy', url: '' }]
				}
			},


			// {
			// 	path: 'temrs-conditions',
			// 	loadChildren: () => import('./pages/terms-conditions/terms-conditions.module').then(m => m.TermsConditionsModule),
			// 	// canActivate: [AuthGuard],
			// 	data: {
			// 		urls: [{ title: 'temrs-conditions', url: '' }]
			// 	}
			// },

			{
				path: 'site-cookies',
				loadChildren: () => import('./pages/site-cookies/site-cookies.module').then(m => m.SiteCookiesModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'site-cookies', url: '' }]
				}
			},
			{
				path: 'our-ethos',
				loadChildren: () => import('./pages/our-ethos/our-ethos.module').then(m => m.OurEthosModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'our-ethos', url: '' }]
				}
			},

			{
				path: 'terms-conditions',
				loadChildren: () => import('./pages/terms-conditions/terms-conditions.module').then(m => m.TermsConditionsModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'terms-conditions', url: '' }]
				}
			},
			{
				path: 'privacy-policy',
				loadChildren: () => import('./pages/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'privacy-policy', url: '' }]
				}
			},
			{
				path: 'gift-card',
				loadChildren: () => import('./pages/gift-card/gift-card.module').then(m => m.GiftCardModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'gift-card', url: '' }]
				}
			},
			{
				path: 'earth-points',
				loadChildren: () => import('./pages/earth-points/earth-points.module').then(m => m.EarthPointsModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'earth-points', url: '' }]
				}
			},


			{
				path: 'cookie',
				loadChildren: () => import('./pages/cookie/cookie.module').then(m => m.CookieModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'cookie', url: '' }]
				}
			},
			{
				path: 'entertainment-outside-venue',
				data: {
					urls: [{ title: 'entertainment-outside-venue', url: '' }],
				},
				component: EntertainmentOutsideVenueComponent
			},
			{
				path: 'entertainment-outside-venue/:vendorPrefixId',
				data: {
					urls: [{ title: 'entertainment-outside-venue', url: '' }],
				},
				component: EntertainmentOutsideVenueComponent
			},
			{
				path: 'entertainment-inside',
				loadChildren: () => import('./pages/entertainment-inside/entertainment-inside.module').then(m => m.EntertainmentInsideModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'Entertainment Inside', url: '' }]
				}
			},


			{
				path: 'finest-pie-range',
				loadChildren: () => import('./pages/finest-pie-range/finest-pie-range.module').then(m => m.FinestModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'Finest Pie Range', url: '' }]
				}
			},
			{
				path: 'proper-fish-and-chips',
				loadChildren: () => import('./pages/proper-fish-and-chips/proper-fish-and-chips.module').then(m => m.ProperFishModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'Proper Fish and Chips', url: '' }]
				}
			},
			{
				path: 'our-brands',
				loadChildren: () => import('./pages/our-brands/our-brands.module').then(m => m.OurBrandsModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'Explore', url: '' }]
				}
			},
			
			{
				path: 'brands',
				loadChildren: () => import('./pages/brands/brands.module').then(m => m.BrandsModule),
				// canActivate: [AuthGuard],
				data: {
					urls: [{ title: 'My Brands', url: '' }]
				}
			},






		]
	},
	{
		path: 'setPassword/:id',
		component: SetPasswordComponent
	},
	{
		path: '**',
		component: NotFoundComponent
	},

];

@NgModule({
	imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: "enabled", initialNavigation: "enabled" })],
	exports: [RouterModule]
})
export class DefaultRoutingModule { }
